<!--
  功能：功能描述
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="qsopen">
        <div class="content">
            <div class="nav">
                <!-- 按钮 -->
                <div class="nav_but" v-if="signShow" @click="gotoSingFunc()">
                    <van-icon name="edit" color="#e4e9fe" /> 立即签约
                </div>
                <div class="nav_but" v-if="loginShow" @click="showPopup = true">
                    <van-icon name="user-o" color="#e4e9fe" /> 登录实盘
                </div>
            </div>
            <img src="@/assets/image/qs/01.jpg" alt="" />
            <img src="@/assets/image/qs/02.jpg" alt="" />
            <img src="@/assets/image/qs/03.jpg" alt="" />
            <img src="@/assets/image/qs/04.jpg" alt="" />
            <img src="@/assets/image/qs/05.jpg" alt="" />
            <img src="@/assets/image/qs/06.jpg" alt="" />
            <img src="@/assets/image/qs/07.jpg" alt="" />
            <img src="@/assets/image/qs/08.jpg" alt="" />
            <img src="@/assets/image/qs/09.jpg" alt="" />

            <p class="risk">
                【风险提示】量化投资存在策略失效风险及市场波动风险。策略模型可能因数据偏差、参数失效、市场环境变化等因素导致收益不及预期；历史回测业绩不代表未来表现。投资者应根据自身风险承受能力独立审慎决策，自行承担投资可能产生的全部损失。
                股市有风险，入市需谨慎。本广告不构成任何投资建议
            </p>

            <div class="footer-but" v-if="signDialog" id="立即签约" @click="gotoSingFunc()" >
                立即签约
            </div>

            <div class="footer">
                <!-- 立即签约 -->
                <!-- <div v-if="signDialog">
                    <div class="f-info">
                        <div class="f-info-left">
                            <p class="name">湘财证券</p>
                            <p class="hint">量化投资签约</p>
                        </div>

                        <p>
                            <img src="@/assets/image/qs/11.png" alt="" class="btn1-icon" @click="gotoSingFunc()" />
                        </p>
                    </div>

                    <p class="expect">更多券商敬请期待</p>
                </div> -->

                <!-- 立即体验 -->
                <div v-if="giftDialog">
                    <div class="f-info f-info2">
                        <div class="f-info-left">
                            <p class="name">点击即送一个月</p>
                            <p class="name">量化投研权限</p>
                            <p class="hint">每个用户限领一次</p>
                        </div>

                        <p>
                            <!-- 赠送按钮 -->
                            <img src="@/assets/image/qs/12.png" alt="" class="btn1-icon" @click="giftUserPowerFunc()" />
                        </p>
                    </div>
                </div>

                <!-- 进入 -->
                <div v-if="spDialog">
                    <div class="f-info">
                        <div class="f-info-left">
                            <div class="head">
                                <img src="@/assets/image/qs/hx.png" alt="" class="head-portrait"
                                    v-if="userInfo.spInfo.qs_type == 1" />
                                <img src="@/assets/image/qs/fz.png" alt="" class="head-portrait"
                                    v-if="userInfo.spInfo.qs_type == 2" />
                                <img src="@/assets/image/qs/xc.png" alt="" class="head-portrait"
                                    v-if="userInfo.spInfo.qs_type == 3" />
                                <div>
                                    <p class="name">
                                        {{
                                            userInfo.spInfo.qs_type == 1
                                                ? '华鑫证券'
                                                : userInfo.spInfo.qs_type == 2
                                        ? '方正证券'
                                        : '湘财证券'
                                        }}
                                    </p>
                                    <p class="num" @click="showPopup = true">
                                        <span>{{ maskString(userInfo.spInfo.capital_id) }}</span>
                                        <van-icon name="setting-o" class="num-icon"></van-icon>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <p class="enterBtn" @click="gotoQsInfo()" >进入</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 弹框 -->
        <van-popup v-model="showPopup" closeable round position="bottom" :style="{ height: '50%' }" class="spEdit">
            <div class="popup-content">
                <h1>登录实盘</h1>
                <div class="label">
                    <p>第一步</p>
                    <p>绑定资金账号</p>
                </div>

                <div class="content-box">
                    <ul class="securities-list">
                        <li v-for="(item, index) in shipan_qslist" :key="index" class="securities-list-item"
                            :class="{ selected: selectedIndex === index }" @click="selectItem(index)">
                            <img src="@/assets/image/qs/hx.png" alt="" v-show="item.value == 1" />
                            <img src="@/assets/image/qs/fz.png" alt="" v-show="item.value == 2" />
                            <img src="@/assets/image/qs/xc.png" alt="" v-show="item.value == 3" />
                            <span class="securities-list-text">{{ item.label }}</span>
                        </li>
                    </ul>

                    <p class="hint">
                        资金账号：
                        <i>（一个大智慧账号只能绑定一个资金账号）</i>
                    </p>

                    <div class="input-box">
                        <van-field v-model="number" placeholder="请输入资金账号"></van-field>
                        <button class="btn" @click="bindingQs()">确认</button>
                    </div>
                </div>

                <!-- <div class="label">
                    <p>第二步</p>
                    <p>导出策略文件</p>
                </div> -->

                <!-- <div class="content-box">
                    <div class="input-box" style="margin-top: 0">
                        <div class="input-re">
                            <van-icon name="arrow-down" class="arrow-down"></van-icon>
                            <van-field readonly clickable :value="selectMnName" placeholder="请选择实盘策略"
                                @click="showPickerInfo()"></van-field>
                        </div>
                        <button class="btn" @click="downloadCl()">导出策略</button>
                    </div>
                </div> -->

                <!-- <p class="step">
                    后续步骤细节参考
                    <a href="#">“量化仿真盘”图文介绍</a>
                </p> -->

                <button class="goSP" @click="gotoQsInfo()" >去实盘页</button>
            </div>
        </van-popup>

        <!-- 选择策略 -->
        <van-popup v-model="showPicker" round position="bottom" class="selCl">
            <van-picker title="选择策略" show-toolbar :columns="columnsMn" @confirm="onConfirm" @cancel="onCancel"
                @change="onChange"></van-picker>
        </van-popup>
        <!-- 弹窗 选择券商页面 -->
        <van-popup v-model="qsDialogShow" round closeable position="bottom" :style="{ height: '30%' }" class="qsqy-info"  >
            <!-- 券商列表 -->
            <div>
                <div class="qs-title" >签约证券</div>
                <div class="qs-list" >
                    <van-radio-group v-model="radioQs">
                        <van-cell-group>
                            <van-cell  clickable @click="radioQs = '1'">
                            <template #title>
                                <div class="radio-item" >
                                    <img src="@/assets/image/qs/hx.png" alt="" class="radio-img" />
                                    <span>湘财证券</span>
                                </div>
                            </template>
                            <template #right-icon>
                                <van-radio name="1" />
                            </template>
                            </van-cell>
                            <van-cell  clickable @click="radioQs = '2'">
                                <template #title>
                                <div class="radio-item" >
                                    <img src="@/assets/image/qs/fz.png" alt="" class="radio-img" />
                                    <span>方正证券</span>
                                </div>
                            </template>
                            <template #right-icon>
                                <van-radio name="2" />
                            </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>



                    <!-- <div v-for="(item, index) in shipan_qslist" :key="index" class="qs-item" >
                        <img src="@/assets/image/qs/hx.png" alt="" v-show="item.value == 1" />
                        <img src="@/assets/image/qs/fz.png" alt="" v-show="item.value == 2" />
                        <img src="@/assets/image/qs/xc.png" alt="" v-show="item.value == 3" />
                        <span class="qs-item-text">{{ item.label }}</span>
                    </div> -->
                </div>
                <div class="qs-but" >
                    <van-button color="#286df7" class="qs-but-info" @click="gotoQsUrl()" >立即签约</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getUserCheck, setUserPower, getMyRealityMn, insertQsInfo,getJsonData,actionSign } from '@/api/index.js';
import { compareVersions } from '@/utils/format';
import CryptoJS from 'crypto-js';
export default {
    name: 'qsopen',
    data() {
        return {
            showPopup: false,
            list: [1],
            selectedIndex: 0,
            number: '',
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
            showPicker: false,
            value: '',
            // 权限集合
            userInfo: {},
            userPower: false,
            // 赠送dialog
            giftDialog: false,
            // 签约弹窗
            signDialog: false,
            // 实盘弹窗
            spDialog: false,
            // 登录按钮
            loginShow: false,
            // 签约按钮
            signShow: false,
            // 获取下载的模拟
            columnsMn: [],
            // 选中的模拟交易
            selectMn: {},
            selectMnName: '',
            selectMySpcl: '', // 加密数据
            // 接受运营参数
            channel: '',
            dzhadid: '',
            reportObj:{},
            // 实盘券商list
            shipan_qslist:[],
            // 签约弹窗
            qsDialogShow:false,
            radioQs:'1'
        };
    },
    filters: {},
    // 侦听器
    watch: {},
    /**
     * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
     */
    created() {
        this.shipan_qslist = window.SHIPAN_QSLIST_TEST;
        // 获取用户权限以及登录信息
        this.getUserInfoFun();
        // 获取用户的模拟交易
        this.getMyRealityMnFunc();
    },
    /**
     * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
     * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
     */
    mounted: function () {
        document.querySelector('html').style.background = '#0a1139';
        this.channel = this.$route.query.channel?this.$route.query.channel:window.config.WEB_CHANNEL;
        this.dzhadid = this.$route.query.dzhadid?this.$route.query.dzhadid:window.config.WEB_DZHADID;
    },
    // 组件方法
    methods: {
        compareVersions,
        selectItem: function (index) {
            this.selectedIndex = index;
        },

        onConfirm: function (value, index) {
            this.selectMn = value;
            this.selectMnName = value.name;
            this.showPicker = false;
            // this.$toast('当前值：' + value + ', 当前索引：' + index);
        },

        onChange: function (picker, value, index) {
            // this.$toast('当前值：' + value + ', 当前索引：' + index);
        },

        onCancel: function () {
            this.showPicker = false;
        },
        // 获取用户信息以及权限
        getUserInfoFun: function () {
            var _this = this;
            var params = {};
            getUserCheck(params)
                .then((result) => {
                    if (result.err == 200) {
                        // 校验成功 (有权限)
                        _this.userInfo = result.data;
                        _this.userPower = true;
                        // 是否绑定过账号
                        if (_this.userInfo.sp) {
                            // 绑定过
                            _this.signDialog = false;
                            _this.spDialog = true;
                            // 打开头部签约按钮
                            _this.signShow = true;
                            // 关闭头部登录按钮
                            _this.loginShow = false;
                            _this.number = _this.userInfo.spInfo.capital_id;
                            // 设置
                            _this.selectedIndex = _this.shipan_qslist.findIndex(item => item.value === _this.userInfo.spInfo.qs_type);
                        } else {
                            // 未绑定过
                            _this.signDialog = true;
                            _this.spDialog = false;
                            // 打开头部签约按钮
                            _this.signShow = false;
                            // 关闭头部登录按钮
                            _this.loginShow = true;
                        }

                        // 赠送弹窗关闭
                        _this.giftDialog = false;
                    } else {
                        // 无权限
                        _this.userInfo = result.data;
                        _this.userPower = false;
                        // 判断是否开过217 , 未开过打开赠送弹窗
                        if (_this.userInfo.code == 'E10002') {
                            // 赠送弹窗打开
                            _this.giftDialog = true;
                            // 关闭
                            _this.signDialog = false;

                            // 判断是否绑定过资金账号
                            if (_this.userInfo.sp) {
                                // 打开头部签约按钮
                                _this.signShow = true;
                                // 关闭头部登录按钮
                                _this.loginShow = false;

                                _this.number = _this.userInfo.spInfo.capital_id;
                                _this.selectedIndex = _this.shipan_qslist.findIndex(item => item.value === _this.userInfo.spInfo.qs_type);
                            } else {
                                // 打开头部签约按钮
                                _this.signShow = false;
                                // 关闭头部登录按钮
                                _this.loginShow = true;
                            }
                        } else if (_this.userInfo.code == 'E10003') {
                            // 无权限,开过217,打开签约弹窗
                            _this.signDialog = true;
                            _this.giftDialog = false;
                            if (_this.userInfo.sp) {
                                // 打开头部签约按钮
                                _this.signShow = true;
                                // 关闭头部登录按钮
                                _this.loginShow = false;
                                _this.number = _this.userInfo.spInfo.capital_id;
                                _this.selectedIndex = _this.shipan_qslist.findIndex(item => item.value === _this.userInfo.spInfo.qs_type);
                                _this.signDialog = false;
                                _this.spDialog = true;
                            } else {
                                // 打开头部签约按钮
                                _this.signShow = false;
                                // 关闭头部登录按钮
                                _this.loginShow = true;


                            }

                        } else {
                            _this.giftDialog = false;
                            _this.signDialog = false;
                        }
                    }
                })
                .catch((err) => {
                    _this.userInfo = {};
                    _this.userPower = false;
                    // 赠送弹窗打开
                    _this.giftDialog = true;
                });
        },
        // 点击赠送权限按钮
        giftUserPowerFunc: function () {
            var _this = this;
            var params = {};
            setUserPower(params)
                .then((result) => {
                    if (result.err == 200) {
                        // 开户成功
                        // 关闭赠送弹窗
                        _this.giftDialog = false;
                        // 打开签约弹窗
                        _this.signDialog = true;
                    } else {
                        // 开户失败
                        _this.giftDialog = true;
                        _this.signDialog = false;
                    }
                })
                .catch((err) => {
                    // 开户失败
                    _this.giftDialog = true;
                    _this.signDialog = false;
                });
        },

        // 获取用户可以导出的模拟交易
        getMyRealityMnFunc: function () {
            var _this = this;
            var params = {};
            getMyRealityMn(params)
                .then((result) => {
                    if (result.data.length > 0) {
                        result.data.forEach((element) => {
                            element.text = element.name;
                        });
                        _this.columnsMn = result.data;
                    }
                })
                .catch((err) => { });
        },

        // 点击显示模拟交易列表
        showPickerInfo: function () {
            var _this = this;
            if (_this.columnsMn.length > 0) {
                _this.showPicker = true;
            } else {
                // 暂无数据
                this.$toast('暂无数据');
            }
        },

        // 点击导出策略
        downloadCl: function () {
            var _this = this;
            // 判断版本号
            if (compareVersions(this.$route.query.version, '10.0.0')) {
                // 判断对象是否为空
                if (Object.keys(_this.selectMn).length > 0) {
                    // 获取用户可以导出的模拟交易
                    // console.log('_this.selectMn',_this.selectMn);
                    this.selectMyClDown();
                } else {
                    // 暂无数据
                    this.$toast('请先创建模拟交易');
                }
            } else {
                // 暂无数据
                this.$toast('请先升级大智慧客户端到最新版本');
            }
        },

        // 处理加密内容
        selectMyClDown: function () {
            var _this = this;
            if (this.userInfo.sp) {
                _this.selectMn.investorId = this.userInfo.spInfo.capital_id;
                var spclSelectAES = _this.encryptData(JSON.stringify(_this.selectMn));
                _this.selectMySpcl = spclSelectAES;
                // 执行下载
                var file_content = _this.selectMySpcl;
                var file_name = _this.selectMnName + '.dzhqf';
                var params = {
                    fileName: file_name,
                    data: file_content
                };
                DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                    'saveFileToLocal',
                    JSON.stringify(params),
                    'downCallback'
                );
                function downCallback(data) {
                    alert(data);
                }
            } else {
                // 暂无数据
                this.$toast('请先绑定资金账号');
            }
        },

        // 加密数据
        encryptData: function (data) {
            var keyInfo = 'jEsp@4H!d2$K9f)#';
            var keyWordArray = CryptoJS.enc.Utf8.parse(keyInfo);
            // 加密数据
            var encryptedData = CryptoJS.AES.encrypt(data, keyWordArray, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7 // 使用PKCS7填充
            }).toString();
            return encryptedData;
        },

        // 绑定券商
        bindingQs: function () {
            var _this = this;
            if (this.number == '') {
                this.$toast('请正确填写资金账号');
            } else {
                var params = {
                    capital_id: _this.number,
                    qs_type: _this.shipan_qslist[_this.selectedIndex].value
                };
                insertQsInfo(params)
                    .then((result) => {
                        if(result.err == 200) {
                            _this.userInfo.sp = true;
                            _this.userInfo.spInfo = params;
                            this.$toast('绑定成功');
                        } else {
                            this.$toast('绑定失败');
                        }
                    })
                    .catch((err) => {
                        this.$toast('绑定失败');
                     });
            }
        },


        // 点击签约按钮
        gotoSingFunc: function () {
            var _this = this;
            // 打开弹窗
            _this.qsDialogShow = true;

        },

        // 点击签约跳转URL
        gotoQsUrl:function(){
            var _this = this;
            if(_this.radioQs == '1') {

                vant.$toast('暂不支持');
                return;

                // // 判断对象是否为空
                // var params = {
                //     source: _this.channel,
                //     mediaid: _this.dzhadid
                // };
                // var url = window.config.WEB_QSOPEN_URL+'&channel='+_this.channel+'&dzhadid='+_this.dzhadid;
                // actionSign(params).then((result) => {
                //     window.location.href = url;
                // }).catch((err) => {
                //     window.location.href = url;
                // });
            } else {
                var url = window.config.WEB_QSOPEN_FZ_URL;
                window.location.href = url;
            }
        },

        // 字符串中间打星号
        maskString(str) {
            if (str.length <= 7) return str;

            const frontLen = 3;
            const backLen = 3;
            const masked = '****';

            return str.slice(0, frontLen) + masked + str.slice(-backLen);
        },
        // 点击跳转到券商
        gotoQsInfo:function(){
            let jsonStr = {
                number: this.number,
                password: '',
            };
            let jsonStr2 = JSON.stringify(jsonStr);
            if(this.userInfo.sp) {
                if(this.userInfo.spInfo.qs_type == 3) {
                    // 跳转湘财
                    window.location.href = window.config.WEB_QSOPEN_URL_XC+"&info=" + btoa(encodeURIComponent(jsonStr2));
                } else if(this.userInfo.spInfo.qs_type == 2) {
                    // 跳转到方正
                    window.location.href = window.config.WEB_QSOPEN_URL_FZ+"&info=" + btoa(encodeURIComponent(jsonStr2));
                } else {
                    this.$toast('敬请期待');
                }
            } else {
                this.$toast('请正确填写资金账号.');
            }
        },
    }
};
</script>

<style scoped lang="less">
.content {
    padding-bottom: 150px;
}

.nav {
    background: rgba(24, 38, 72, 0.2);
    backdrop-filter: blur(14px);
    position: fixed;
    top: 0;
    width: 100%;
    height: 71px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;

    .nav_but {
        padding: 8px 12px;
        background: rgba(255, 255, 255, 0.06);
        border-radius: 15px;
        color: #e4e9fe;
        font-size: 13px;
        margin-right: 16px;
    }
}

.nav .nav-right {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #fff;
    line-height: 14px;
}

.nav .nav-right button {
    width: 106px;
    height: 35px;
    font-size: 16px;
    font-weight: 500;
    color: #4173ff;
    border: 1px solid #4173ff;
    border-radius: 30px;
    background: #000000;
    margin-left: 10px;
}

.footer {
    position: fixed;
    width: 100%;
    left: 50%;
    bottom: 0;
    max-width: 750px;
    transform: translateX(-50%);
    background: url('../../assets/image/qs/10.png') no-repeat center;
    background-size: 100% 100%;
    border-radius: 20px 20px 0 0;
}

.footer-but {
    position: fixed;
    width: 90%;
    left: 50%;
    bottom: 30px;
    max-width: 750px;
    transform: translateX(-50%);
    background: url('../../assets/image/qs/qsbut.png') no-repeat center;
    background-size: 100% 100%;
    height: 50px;
    font-weight:500;
    color:#ffffff;
    font-size:20px;
    line-height: 50px;
    text-align: center;
    // border-radius: 20px 20px 0 0;
}

.footer .f-info {
    padding: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.footer .f-info .f-info-left .name {
    font-size: 26px;
    font-weight: bold;
    //   margin-bottom: 5px;
    font-family: Alimama ShuHeiTi;
    color: #fff;
}

.footer .f-info .f-info-left .hint {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.6);
    //   margin-top: 0.2rem;
}

.footer .f-info .btn1-icon {
    width: 150px;
}

.risk {
    font-size: 0.24rem;
    line-height: 0.32rem;
    padding: 0 0.4rem;
    color: #fff;
}

.footer .expect {
    font-size: 10px;
    position: absolute;
    right: 30px;
    bottom: 10px;
    color: #fff;
}

.footer .f-info2 .f-info-left .name {
    background: linear-gradient(0deg, #ffffff -300%, #fff2b1 400%),
        linear-gradient(0deg, #ffffff -300%, #fff2b1 400%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
}

.footer .f-info2 .btn1-icon {
    width: 125px;
}

.footer .f-info .enterBtn {
    width: 85px;
    height: 40px;
    background: linear-gradient(180deg, #ffdb8e 0%, #ffa532 100%);
    border-radius: 7.69px;
    flex-shrink: 0;
    font-weight: 500;
    color: #732d10;
    font-size: 0.38rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer .f-info .f-info-left .head {
    display: flex;
    align-items: center;
}

.footer .f-info .f-info-left .head .head-portrait {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
}

.footer .f-info .f-info-left .num {
    color: #ffffff;
    font-size: 15px;

    .num-icon {
        margin-left: 8px;
    }
}

#app .van-popup {
    background: #1b2035;
}

#app .spEdit {
    padding: 0.7rem 0.3rem 0.46rem;
}

/* #app .van-popup--bottom {
  max-width: 750px;
  left: 50%;
  transform: translateX(-50%);
} */

.popup-content {
    /* border: 1px solid #f00; */
}

.popup-content h1 {
    font-weight: 500;
    color: #e4e9fe;
    font-size: 17px;
    text-align: center;
}

.popup-content .label {
    display: flex;
    align-items: center;
    margin-top: 28px;
}

.popup-content .label p {
    font-weight: 500;
    color: #e4e9fe;
    font-size: 15px;
}

.popup-content .label p:first-child {
    background: rgba(59, 133, 254, 0.3);
    border-radius: 4px;
    padding: 0.16rem 0.16rem;
    margin-right: 0.16rem;
}

.popup-content .content-box {
    background: rgba(255, 255, 255, 0.04);
    border-radius: 11.54px;
    padding: 0.23rem;
    margin-top: 12px;
}

.popup-content .content-box .securities-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    // align-items: center;

}

.popup-content .content-box .securities-list .securities-list-item {
    width: 48%;
    margin-bottom: 10px;
}


// .popup-content .content-box .securities-list li:first-child {
//     margin-right: 0.15rem;
// }

.popup-content .content-box .securities-list li {
    background: rgba(98, 100, 132, 0.16);
    border-radius: 11.54px;
    width: 50%;
    padding: 8px 15px;
    border: 1px solid rgba(98, 100, 132, 0);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;

    .securities-list-text {
        margin-left: 8px;
        color: #e4e9fe;
        font-size: 13px;
    }
}

.popup-content .content-box .securities-list li img {
    width: 27px;
    height: 27px;
    border-radius: 7px;
}

.popup-content .content-box .securities-list li.selected {
    border: 1px solid #3b85fe;
    background: #253e71;
}

.popup-content .content-box .hint {
    color: #e4e9fe;
    font-size: 14px;
    margin-top: 16px;
}

.popup-content .content-box .hint i {
    color: #909cb0;
    font-size: 12px;
}

.popup-content .content-box .input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    color: #e4e9fe;
}

.popup-content .content-box .input-box .input-re {
    width: 100%;
    position: relative;
}

.popup-content .content-box .input-box .input-re .arrow-down {
    position: absolute;
    z-index: 9;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
}

.popup-content .content-box .input-box .van-cell {
    background: #2e3248;
    border: 1px solid;
    border-color: #383c54;
    border-radius: 11.54px;
    padding: 6px 15px;
    font-size: 13px;
}

.popup-content {
    ::v-deep {
        .van-field__control {
            color: #e4e9fe;
            font-size: 13px;
        }
    }
}

.popup-content .van-cell::after {
    display: none;
}

.popup-content .btn {
    width: 77px;
    height: 31px;
    background: #3b85fe;
    border-radius: 7.69px;
    color: #ffffff;
    font-size: 13px;
    margin-left: 8px;
}

#app .van-picker {
    background: none;
}

::v-deep {
    .van-picker__mask {
        background-image: none;
    }
}

::v-deep {
    .van-picker-column__item {
        color: #e4e9fe;
    }
}

.van-popup {
    background: #1b2035;
}

.selCl {
    ::v-deep {
        .van-picker__title {
            color: #fff;
        }

        .van-picker__confirm {
            color: #3b85fe;
        }
    }
}

.selCl .van-picker__confirm {
    color: #3b85fe;
}

.popup-content .step {
    margin-top: 28px;
    color: #6b7687;
    font-size: 12px;
    text-align: center;
}

.popup-content .step a {
    color: #3b85fe;
}

.popup-content .goSP {
    margin-top: 40px;
    width: 100%;
    height: 40px;
    background: #3b85fe;
    border-radius: 7.69px;
    color: #ffffff;
    font-size: 15px;
}

// 签约
.qsqy-info {
    padding: 16px;
    .qs-title {
        font-weight:500;
        font-size:16px;
        text-align: center;
        color: #e4e9fe;
    }
    .qs-list {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        .van-radio-group {
            width: 100%;
        }
        .van-cell-group {
            background-color: #1b2035;
        }
        .van-cell {
            width: 100%;
             background: rgba(98, 100, 132, 0.16);
             margin-top: 10px;
             color: #e4e9fe;
        }
        .van-cell::after {
            display: none;
        }

        .radio-item {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-start;
            align-items: center;
        }

        .radio-img {
             width: 27px;
            height: 27px;
            border-radius: 7px;
            margin-right: 8px;
        }
        .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
            display: none;
        }


    }
    .qs-but {
            width: 100%;
            .qs-but-info {
                width: 100%;
                margin-top: 10px;
            }
        }
}

</style>
